export const SKILL_IDS = {
  ZERO: "R20.F00.ZERO",
  SPLIT_5: "R20.F01.SPLIT_5",
  SPLIT_10: "R20.F02.SPLIT_10",
  TEEN_STRUCTURE: "R20.F03.TEEN_STRUCTURE",
  PLUS_MINUS_1: "R20.A01.PLUS_MINUS_1",
  PLUS_MINUS_2: "R20.A02.PLUS_MINUS_2",
  DOUBLES: "R20.A03.DOUBLES",
  MAKE_10: "R20.A04.MAKE_10",
  NEAR_DOUBLES: "R20.A05.NEAR_DOUBLES",
  BASIC_TO_10: "R20.A06.BASIC_TO_10",
  COMMUTATIVE: "R20.R01.COMMUTATIVE",
  INVERSE: "R20.R02.INVERSE",
  TEEN_NO_BRIDGE: "R20.T01.TEEN_NO_BRIDGE",
  CROSS_10_ADD: "R20.T02.CROSS_10_ADD",
  CROSS_10_SUB: "R20.T03.CROSS_10_SUB",
  AUTOMATE: "R20.M01.AUTOMATE",
  MEMORIZE: "R20.M02.MEMORIZE",
  MAINTAIN: "R20.M03.MAINTAIN",
  TRANSFER: "R20.X01.TRANSFER",
} as const;

export const STRATEGY_IDS = {
  ZERO_IDENTITY: "ZERO_IDENTITY",
  COUNT_ON: "COUNT_ON",
  COUNT_BACK: "COUNT_BACK",
  DOUBLES: "DOUBLES",
  MAKE_10: "MAKE_10",
  NEAR_DOUBLE: "NEAR_DOUBLE",
  COMMUTE: "COMMUTE",
  INVERSE_FACT: "INVERSE_FACT",
  TEEN_ANALOGY: "TEEN_ANALOGY",
  VIA_10_ADD: "VIA_10_ADD",
  BACK_VIA_10: "BACK_VIA_10",
} as const;
